/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : Footer.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : Footer component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : December 16, 2021
 *
 * @Version      : Version 1.0
 *
 * By            :
 * On            :
 * Description   :
 *
 *
 ******************************************************************************/

import React, { FC } from "react";
import { useSelector } from "react-redux";
import { Footer, Grid } from "@scuf/common";
import { selectUserInfo } from "stores/AuthStore";
import "./Footer.scss";
import privacyImage from "./ccpa-privacyoptions.svg";

export const FooterComponent: FC = () => {
  const userInfo = useSelector(selectUserInfo);
  return userInfo ? (
    <Grid className="app-footer">
      <Grid.Row>
        <Grid.Column className="footer-container">
          <Footer copyrightText="" className="custom-footer">
            <Footer.Item className="inactiveLink">
              Copyright © 2020 Honeywell International Inc.
            </Footer.Item>
            <Footer.Item
              href="https://www.honeywellaerospace.com/us/en/terms-and-conditions"
              target="_blank"
            >
              Terms &amp; Conditions
            </Footer.Item>
            <Footer.Item
              href="https://www.honeywellaerospace.com/us/en/privacy-statement"
              target="_blank"
            >
              Privacy Statement
            </Footer.Item>
            <Footer.Item
              href="https://hon-opcenter.my.salesforce-sites.com/PrivacyInformationRequestForm?lang=en"
              target="_blank"
            >
              Your Privacy Choices &nbsp;
              <img src={privacyImage} className="footer-icon" alt="icon" />
            </Footer.Item>
            <Footer.Item
              href="https://www.honeywellaerospace.com/en/redirects/external/cookies"
              target="_blank"
            >
              Cookies
            </Footer.Item>
            <Footer.Item
              href="https://www.honeywellaerospace.com/en/redirects/external/global-unsubscribe"
              target="_blank"
            >
              Global Unsubscribe
            </Footer.Item>
          </Footer>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  ) : null;
};
